import { DatePipe } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { SettingsService } from 'src/app/services/settings.service';

@Pipe({
    name: 'date',
    pure: false,
    standalone: false
})
export class LocalizedDatePipe extends DatePipe implements PipeTransform {
  constructor(
    private settingsService: SettingsService,
    @Inject(LOCALE_ID) locale: string
  ) {
    super(locale);
  }

  transform(value: any, pattern: string = 'mediumDate'): any {
    let dateFormat = this.settingsService.get().dateFormat;
    let localizedDatePattern = pattern.replace('yyyy-MM-dd', dateFormat);
    let transformedDate = super.transform(value, localizedDatePattern);
    return transformedDate;
  }
}
